/**
 * Métricas del Agente
 */

export interface MetricsPoint {
  timestamp: number;
  value: number;
}

export interface DiskInfo {
  path: string;
  fstype?: string;
  totalBytes: number;
  usedBytes: number;
  freeBytes: number;
  usedPercent: number;
}

export interface AgentMetrics {
  cpuPercent: number;
  memUsedBytes: number;
  memTotalBytes: number;
  diskUsedBytes: number; // legacy
  diskTotalBytes: number; // legacy
  disks?: DiskInfo[];
  processes: ProcessInfo[];
  activeApp?: {
    name: string;
    pid: number;
    available: boolean;
    reason?: string;
  };
}

export interface ProcessInfo {
  pid: number;
  name: string;
  cpuPercent: number;
  memBytes: number;
}

export interface MetricsHistory {
  cpu: MetricsPoint[];
  memory: MetricsPoint[];
  disk: MetricsPoint[];
  timestamp: number;
}

export const formatBytes = (bytes: number): string => {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const formatPercent = (percent: number): string => {
  return percent.toFixed(1) + '%';
};
